<template>
    <portal v-if="$slots.default || text" to="header" :order="1">
        <h1 class="page-title-heading">
            <span class="page-title-heading__text"
                ><slot>{{ text }}</slot></span
            >
            <slot name="append"></slot>
        </h1>
    </portal>
</template>

<script>
export default {
    props: {
        title: String,
        translated: String,
        // replaces the app name after the "|" in the browser tab title while set
        documentTitleSuffix: String,
        // between the heading and the suffix in the browser tab title
        documentTitleSeparator: {
            type: String,
            default: ' | ',
        },
    },
    data: () => ({
        observer: null,
    }),
    computed: {
        text() {
            return this.translated
                ? this.translated
                : this.title
                ? this.$t(this.title)
                : null
        },
    },
    watch: {
        text: {
            immediate: false,
            handler() {
                this.setDocumentTitle()
            },
        },
        documentTitleSuffix() {
            this.setDocumentTitle()
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.setDocumentTitle()
            const heading = document.querySelector('.page-title-heading')
            // no heading while the title is still empty (entity not loaded); the watchers cover it
            if (!heading) {
                return
            }
            const observer = new MutationObserver(this.setDocumentTitle)
            observer.observe(heading, {
                childList: true,
                subtree: true,
                characterData: true,
            })
            this.observer = observer
        })
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect()
        }
    },
    methods: {
        setDocumentTitle() {
            const text =
                this.text ||
                this.$slots.default?.[0]?.text ||
                document.querySelector('.page-title-heading__text')?.textContent
            const suffix =
                this.documentTitleSuffix || this.$t('global.app_title')
            document.title = `${text}${this.documentTitleSeparator}${suffix}`
        },
    },
}
</script>

<style lang="scss">
// one line in the fixed-height app bar: a long title ends in an ellipsis instead of wrapping up
// into the breadcrumb trail (phones, sweep 2026-11-04); what follows it (a count, a badge) stays
.page-title-heading {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 12px;
    min-width: 0;
    max-width: 100%;

    > * {
        flex-shrink: 0;
    }

    > .page-title-heading__text {
        flex-shrink: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
